export const LISTING_FIELD_KEYS = {
  PRODUCER_TYPE_CATEGORY: 'producer_type_category',
  TYPE: 'type',
  MARKETS_EVENTS: 'markets_events',
  PRODUCERS_PLACES: 'producers_places',
  FEATURES: 'features',
  PLACETYPE: 'placetype',
  FARM_TO_FORK_DINING_FEATURES: 'farm_to_fork_dining_features',
};